export const PaymentEditListI18n = {
    title: {
        singular: 'Payment Method - Override',
        plural: 'Payment Methods - Override',
    },
    balance: {
        title: 'Account Balance - Override',
        prefix: 'Current balance: - Override',
        hint: 'Fund your account - Override',
        errors: {
            insufficientFunds:
                'There are insufficient funds in your account to complete your purchase. Please choose another payment method below. - Override',
        },
    },
    bank: {
        title: 'Bank Account - Override',
        subtitle: 'Instant - Override',
        actions: {
            update: 'Update - Override',
        },
    },
    card: {
        title: 'Card - Override',
        feePrefix: 'Instant - Override',
        feeSuffix: 'Processing fee - Override',
        limitsWarning: 'Payment transactions above {{ maxAmount }} require ACH via linked bank account - Override',
        actions: {
            update: 'Update - Override',
            alerts: {
                confirmUpdate: {
                    title: `Update Credit Card - Override`,
                    descr: ` Are you sure you would like to update your credit card? <br/> <br/> Please note that previously added credit card will be deleted. - Override`,
                },
            },
        },
    },
};
